import { HistoricalPercentageChangeDataItem } from 'widgets/historicalPercentageChange/data/historicalPercentageChangeDataItem.ts';
import { HistoricalPercentageChangeChart } from 'widgets/historicalPercentageChange/components/HistoricalPercentageChangeChart/HistoricalPercentageChangeChart.tsx';
import { styleConstants as tileStyleConstants } from 'widgets/tiles/components/styles/variables.module.constants';

import './HistoricalPercentageChangeCapsuleFront.scss';
import { useRef } from 'react';
import { BarMouseOver } from 'widgets/historicalPercentageChange/components/HistoricalPercentageChangeChart/barMouseOver.ts';
import { HistoricalPercentageChangeCapsuleFrontHeader } from 'widgets/historicalPercentageChange/capsule/components/HistoricalPercentageChangeCapsuleFrontHeader.tsx';

import 'widgets/tiles/components/tile/TileTimeSeriesChart.scss';
import { useHistoricalPercentageChangeCapsuleConfigSlice } from 'widgets/historicalPercentageChange/capsule/store.ts';

export function HistoricalPercentageChangeCapsuleFront({
    averageVolume,
    items,
    onClick: onClickProps,
}: {
    averageVolume: number | undefined;
    items: HistoricalPercentageChangeDataItem[];
    onClick: (item?: HistoricalPercentageChangeDataItem) => void;
}) {
    const mouseOverRef = useRef(new BarMouseOver());

    const {
        config: { hideAverageVolume, hidePrice, hideVolume, periodQty },
    } = useHistoricalPercentageChangeCapsuleConfigSlice();

    const height = 82;

    const onClick = () => {
        onClickProps(mouseOverRef.current.context?.item);
    };

    return (
        <div
            className="HistoricalPercentageChangeCapsuleFront"
            onClick={onClick}
        >
            <HistoricalPercentageChangeCapsuleFrontHeader
                averageVolume={averageVolume}
                barMouseOver={mouseOverRef.current}
                data={items}
            />
            <HistoricalPercentageChangeChart
                barMouseOver={mouseOverRef.current}
                className={'TileTimeSeriesChart'}
                hideAverageVolume={hideAverageVolume}
                hidePrice={hidePrice}
                hideVolume={hideVolume}
                hideYAxis={true}
                data={items}
                height={height}
                pricePointSize={7}
                periodQty={periodQty}
                width={tileStyleConstants.tileWidth}
            />
        </div>
    );
}
